import { type StrokeStyleOption } from '../types';

export const DASHARRAY_LIST: StrokeStyleOption[] = [
    { value: '', linecap: '' },
    { value: '2,1', linecap: '' },
    { value: '1,1', linecap: '' },
    { value: '2.5,0.5,0.5,0.5', linecap: '' },
    { value: '2.5,0.5,0.5,0.5,0.5,0.5', linecap: '' },
];
